export default {
  root: {
    width: "unset",
    borderRadius: "unset",
  },
};
